import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Table,
  Button,
  Form,
  InputGroup,
  FormControl,
  FormText,
} from "react-bootstrap";
import moment from "moment";
import { InputLabel, Select } from "@mui/material";
import { MenuItem } from "semantic-ui-react";

const AdminLeadManage = () => {
  const [assignedLeads, setAssignedLeads] = useState([]);

  useEffect(() => {
    fetchAssignedLeads();
  }, []); // Fetch leads on component mount

  const fetchAssignedLeads = async () => {
    try {
      const response = await axios.get(
        "/api/admin/getLead"
      );
      console.log("Received leads:", response.data.adminLeads);
      setAssignedLeads(response.data.adminLeads);
    } catch (error) {
      console.error(
        "Error fetching assigned leads:",
        error.response ? error.response.data : error.message
      );
    }
  };

  const [teachers, setTeachers] = useState([]);
  const [selectedTeacher, setSelectedTeacher] = useState("");
  const [selectedTime, setSelectedTime] = useState("");
  const [studentName, setStudentName] = useState("");
  const [contactDetails, setContactDetails] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [date, setDate] = useState([]);
  const [mode, setMode] = useState([]);

  const [demoData, setDemoData] = useState([]);

  useEffect(() => {
    fetchTeachers();
    fetchDemo();
  }, []);

  const fetchTeachers = async () => {
    try {
      const response = await axios.get(
        "/api/admin/getTeachers"
      );
      console.log("Get Teachers", response);
      setTeachers(response.data);
    } catch (error) {
      console.error("Error fetching teachers:", error);
    }
  };

  const fetchDemo = async () => {
    try {
      const res = await axios.get("/api/admin/getDemo");
      console.log("Get Demo", res);

      setDemoData(res.data);
    } catch (err) {
      console.log("error", err);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await axios.post("/api/admin/scheduleDemo", {
        studentName,
        contactDetails,
        teacher: selectedTeacher, // This should be a valid ObjectId
        scheduledTime: selectedTime,
        date: date,
        classMode: mode,
      });
      console.log("Selected Teacher ID:", selectedTeacher);

      alert("Demo class scheduled successfully!");
      setErrorMessage("");
      fetchDemo();
    } catch (error) {
      setErrorMessage("Failed to schedule demo class.");
      setSuccessMessage("");
      console.error(error); // Add this line to see the full error in console
    }
  };

  //     const [adminLead, setAdminLead] = useState([]);

  // useEffect(() => {
  //     fetchAdminLead();
  // }, []);

  // const fetchAdminLead = async () => {
  //     try {
  //         const response = await axios.get('/api/admin/getLead');
  //         setAdminLead(response.data.adminLeads);

  //     } catch (error) {
  //         console.error('Error fetching leads:', error);
  //     }
  // };

  const handleChangeDemoStatus = async (id, newDemoStatus) => {
    try {
      console.log("Demo ID:", id);

      const response = await axios.put(
        `/api/admin/updateDemo/${id}`,
        { status: newDemoStatus }
      );

      alert("Status updated successfully!");
      fetchDemo();
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  // const [studentId, setStudentId] = useState('');  // Assuming studentId is set dynamically
  // const [teacherId, setTeacherId] = useState('');  // Assuming teacherId is set dynamically
  const [feedbackByStudent, setFeedbackByStudent] = useState("");
  const [feedbackByTeacher, setFeedbackByTeacher] = useState("");
  const [studentFeedName, setStudentFeedName] = useState(""); // Assuming student name is available
  const [teacherName, setTeacherName] = useState(""); // Assuming teacher name is available
  const [feedback, setFeedback] = useState([]);

  const fetchFeedback = async () => {
    try {
      const response = await axios.get(
        "/api/admin/getFeedback",
        {}
      );
      console.log("Feedback", response);
      setFeedback(response.data);
    } catch (error) {
      console.error("Error fetching feedback:", error);
    }
  };

  useEffect(() => {
    fetchFeedback();
  }, []);

  const handleFeedbackSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        "/api/admin/addFeedback",
        {
          feedbackByStudent,
          feedbackByTeacher,
          studentName: studentFeedName,
          TeacherName: teacherName,
        }
      );
      alert("Feedback submitted successfully");
      setFeedbackByStudent("");
      setFeedbackByTeacher("");
      setStudentFeedName("");
      setTeacherName("");
    } catch (error) {
      console.error("Error submitting feedback:", error);
      alert("Error submitting feedback");
    }
  };
  return (
    <>
      <div className="container mt-5">
        <h3 style={{ color: "#00a695" }}>Assigned Leads</h3>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>S.No</th>
              <th>Student Name</th>
              <th>Contact Details</th>
              <th>Subject Preferences</th>
              <th>Location</th>
              <th>Type of Class</th>
              <th>Status</th>
              <th>Assigned SubAdmin</th>
            </tr>
          </thead>
          <tbody>
            {assignedLeads.map((lead, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{lead.studentName}</td>
                <td>{lead.contactDetails}</td>
                <td>{lead.subjectPreference}</td>
                <td>{lead.location}</td>
                <td>{lead.TypeOfClass}</td>
                <td>{lead.status}</td>
                <td>
                  {lead.assignedTo ? lead.assignedTo.name : "Not Assigned"}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      <div className="container mt-5 mb-5">
        <h3 style={{ color: "#00a695" }}>Schedule Demo Class</h3>
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="studentName">
            <Form.Control
              type="text"
              placeholder="Enter student name"
              value={studentName}
              onChange={(e) => setStudentName(e.target.value)}
              required
              className="mb-3 w-50"
            />
          </Form.Group>

          <Form.Group controlId="contactDetails">
            <Form.Control
              type="text"
              placeholder="Enter contact details"
              value={contactDetails}
              onChange={(e) => setContactDetails(e.target.value)}
              required
              className="mb-3 w-50"
            />
          </Form.Group>

          <Form.Group controlId="teacherSelect">
            <Form.Control
              // as="select"
              type="text"
              value={selectedTeacher}
              placeholder="Teacher Name"
              onChange={(e) => setSelectedTeacher(e.target.value)}
              required
              className="mb-3 w-50"
            >
              {/* <option value="">Select Teacher</option>
                        {teachers.map((teacher) => (
                            <option key={teacher._id} value={teacher._id}>
                                {teacher.name}
                            </option>
                        ))} */}
            </Form.Control>
          </Form.Group>
          <Form.Group controlId="mode">
            <Form.Control
              type="text"
              value={mode}
              placeholder="Class Mode"
              onChange={(e) => setMode(e.target.value)}
              className="mb-3 w-50"
            ></Form.Control>
          </Form.Group>

          <Form.Group controlId="date">
            <Form.Control
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              className="mb-3 w-50"
            />
          </Form.Group>

          <Form.Group controlId="time">
            <Form.Control
              type="time"
              value={selectedTime}
              onChange={(e) => setSelectedTime(e.target.value)}
              required
              className=" w-50"
            />
          </Form.Group>

          <Button
            className="mt-3"
            type="submit"
            style={{ backgroundColor: "#00a695", color: "white", border: "0" }}
          >
            Schedule Demo
          </Button>
        </Form>

        {successMessage && <p style={{ color: "green" }}>{successMessage}</p>}
        {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
      </div>

      <div className="container mt-5 mb-5">
        <h3 style={{ color: "#00a695" }}>Demo Class Details</h3>
        <Table striped bordered hover>
          <thead>
            <tr className="text-center">
              <th>S.No</th>
              <th>Student Name</th>
              <th>Contact Details</th>
              <th>Teacher</th>
              <th>Status</th>
              <th>Mode</th>
              <th>Date</th>
              <th>Time</th>
            </tr>
          </thead>
          <tbody className="text-center">
            {demoData.map((lead, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{lead.studentName}</td>
                <td>{lead.contactDetails}</td>
                <td>{lead.teacher}</td>
                <td>
                  <select
                    className="form-select"
                    value={lead.status}
                    onChange={(e) =>
                      handleChangeDemoStatus(lead._id, e.target.value)
                    }
                  >
                    <option value="Demo Scheduled">Demo Scheduled</option>
                    <option value="Demo Completed">Demo Completed</option>
                    <option value="Demo Converted">Demo Converted</option>
                    <option value="Not Interested">Not Interested</option>
                  </select>
                </td>
                <td>{lead.classMode}</td>
                <td>
                  {lead.date ? moment(lead.date).format("MM/DD/YYYY") : "N/A"}
                </td>{" "}
                <td>{lead.scheduledTime}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      <div className="container mt-4">
        <h3 style={{ color: "#00a695" }}>Add Feedback</h3>
        {/* Form for submitting feedback */}
        <form onSubmit={handleFeedbackSubmit} className="mb-4">
          <div className="row">
            <div className="col-md-6 mb-3">
              <label htmlFor="studentFeedName" className="form-label">
                Student Name
              </label>
              <input
                type="text"
                id="studentFeedName"
                className="form-control"
                value={studentFeedName}
                onChange={(e) => setStudentFeedName(e.target.value)}
                placeholder="Enter Student Name"
                required
              />
            </div>
            <div className="col-md-6 mb-3">
              <label htmlFor="teacherName" className="form-label">
                Teacher Name
              </label>
              <input
                type="text"
                id="teacherName"
                className="form-control"
                value={teacherName}
                onChange={(e) => setTeacherName(e.target.value)}
                placeholder="Enter Teacher Name"
                required
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label htmlFor="feedbackByStudent" className="form-label">
                Student Feedback
              </label>
              <textarea
                id="feedbackByStudent"
                className="form-control"
                rows="3"
                value={feedbackByStudent}
                onChange={(e) => setFeedbackByStudent(e.target.value)}
                placeholder="Enter your feedback"
                required
              />
            </div>
            <div className="col-md-6 mb-3">
              <label htmlFor="feedbackByTeacher" className="form-label">
                Teacher Feedback
              </label>
              <textarea
                id="feedbackByTeacher"
                className="form-control"
                rows="3"
                value={feedbackByTeacher}
                onChange={(e) => setFeedbackByTeacher(e.target.value)}
                placeholder="Enter your feedback"
                required
              />
            </div>
          </div>
          <button
            type="submit"
            className="btn"
            style={{ backgroundColor: "#00a695", color: "white" }}
          >
            Submit Feedback
          </button>
        </form>

        {feedback && (
          <div>
            <div className="table-responsive">
              <h2 style={{ color: "#00a695" }}>Student Feedback Details</h2>
              <table className="table table-bordered text-center">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Student Name</th>
                    <th>Feedback</th>
                  </tr>
                </thead>
                <tbody>
                  {feedback.map((feedbackItem, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{feedbackItem.studentName}</td>
                      <td>{feedbackItem.feedbackByStudent}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="table-responsive">
              <h2 style={{ color: "#00a695" }}>Teacher Feedback Details</h2>
              <table className="table table-bordered text-center">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Teacher Name</th>
                    <th>Feedback</th>
                  </tr>
                </thead>
                <tbody>
                  {feedback.map((feedbackItem, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{feedbackItem.TeacherName}</td>
                      <td>{feedbackItem.feedbackByTeacher}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default AdminLeadManage;
